import Image from "next/image";
import type { ColumnImageFields } from "@/types/acf";
import { toAbsoluteUrl } from "@/lib/toAbsoluteUrl";

const ratioClassMap: Record<NonNullable<ColumnImageFields["aspect_ratio"]>, string> = {
  "3-2": "aspect-[3/2]",
  "1-1": "aspect-square",
};

export default function ColumnImage({ data }: { data: ColumnImageFields }) {
  const hide = (data as unknown as { hide?: boolean })?.hide;
  if (!data || hide) return null;

  const img = data.image;
  if (!img?.url) return null;

  const src = toAbsoluteUrl(img.url);
  if (!src) return null;

  const ratioClass = ratioClassMap[data.aspect_ratio ?? "3-2"];

  return (
    <div className="w-full">
      <div className={`relative w-full ${ratioClass} overflow-hidden`}>
        <Image
          src={src}
          alt={img.alt || "Image"}
          fill
          className="object-cover"
          sizes="(min-width: 1024px) 50vw, 100vw"
        />
      </div>
    </div>
  );
}

